module.exports = __webpack_public_path__ + "img/ambit-cares.0b74854d.jpg";